/**
 */

import React, { Component } from 'react';
import Axios from 'axios';
import ShortcutButton from './ShortcutButton';
import BasemapDialogue from './BasemapDialogue';
import { toggleShortcutMenu, toggleMenu, toggleLegend } from '../../modules/App/AppState';
import { connect } from 'react-redux';
import { composeUrlFromUrlParams } from '../UrlUtils';
import { history } from '../../modules/App/AppContainer';
import classNames from 'classnames';
import './shortcutmenu.scss';

class ShortcutMenu extends Component {

  constructor() {
    super();

    this.state = {
      isVisible: false,
      isBasemapDialogueVisible: false,
      warnings: { severity: 0 },
    };

    this.onMenuToggle = this.onMenuToggle.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onBasemapClick = this.onBasemapClick.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentWillMount() {
    if (this.props.loadWarningsConfigFn) {
      this.props.loadWarningsConfigFn()
        .then(res => {
          this.setState({ warnings: res.data });
        })
        .catch(err => console.log(err));
    } else {
      Axios.get(this.props.warningsUrl)
        .then(res => {
          this.setState({ warnings: res.data });
        })
        .catch(err => console.log(err));
    }
  }

  onKeyPress(e) {
    if (e.which === 27) {
      this.onMenuToggle();
    }
  }

  onButtonClick(type) {
    if (type === 'overlays') {
      this.setState({ isVisible: false });
      this.props.dispatch(toggleMenu());
    }

    if (type === 'livecams') {
      const url = composeUrlFromUrlParams(this.props.urlParams, 'optional', 'livecams');
      history.push(url);
    }

    if (type === 'favorites') {
      const url = composeUrlFromUrlParams(this.props.urlParams, 'optional', 'hidefavs');
      history.push(url);
    }

    if (type === 'legend') {
      this.props.dispatch(toggleLegend());
    }
  }

  onBasemapClick() {
    this.setState({ isBasemapDialogueVisible: !this.state.isBasemapDialogueVisible });
  }


  onMenuToggle() {
    if (this.state.isVisible) {
      document.removeEventListener('keyup', this.onKeyPress);
    } else {
      document.addEventListener('keyup', this.onKeyPress);
    }
    this.props.dispatch(toggleShortcutMenu());
    this.setState({ isVisible: !this.state.isVisible });
  }

  render() {
    const containerClasses = classNames(
      'shortcut-container',
      {
        'shortcut-container-visible': this.state.isVisible,
      });

    const mainIconClass = classNames(
      {
        'icon-more': !this.state.isVisible,
        'icon-close': this.state.isVisible,
      }
    );

    const showWarningsButton = this.state.warnings.severity > 0;

    return (
      <div>
        <div className={containerClasses} onClick={this.onMenuToggle}></div>
        <div className="shortcut-container-wrapper">
          <div className="shortcut-container-inside">
            <div className="shortcut-container-inside-wrapper">
              <ShortcutButton icon="icon-info" isVisible={this.state.isVisible} isActiveState={this.props.legendVisible} id="legend" label="Legende ein/ausblenden" clickHandler={this.onButtonClick} />
              <ShortcutButton icon="icon-background" isVisible={this.state.isVisible} isActiveState={this.state.isBasemapDialogueVisible} id="basemap" label="Hintergrund ändern" clickHandler={this.onBasemapClick} >
              {this.state.isBasemapDialogueVisible ?
                <div className="shortcut-basemaps">
                  <div className="delta text--blue-dark">
                    Hintergrund auswählen
                    <i className="float--right text--center pt-- filter--flat icon-close"></i>
                  </div>
                  <BasemapDialogue basemaps={this.props.basemaps} activeBasemapId={this.props.urlParams.basemap} />
                </div>
              : null}
              </ShortcutButton>
              <ShortcutButton icon="icon-map-pin" isVisible={this.state.isVisible} isActiveState={this.props.urlParams.optional && this.props.urlParams.optional.indexOf('hidefavs') === -1} id="favorites" label="Zuletzt besuchte Orte" clickHandler={this.onButtonClick} />
              <ShortcutButton icon="icon-icon_specials" isVisible={this.state.isVisible} isActiveState={this.props.urlParams.optional && this.props.urlParams.optional.indexOf('livecams') !== -1} id="livecams" label="HD Live Webcams" clickHandler={this.onButtonClick} />
              {showWarningsButton ?
                <a id="button-warnings" href={this.state.warnings.link}>
                  <ShortcutButton icon="icon-danger" isVisible={!this.state.isVisible} isActiveState={false} id="warnings" label="Aktuelle Warnungen" clickHandler={this.onButtonClick}>
                    <div className="shortcut-alert-button">{this.state.warnings.label}</div>
                  </ShortcutButton>
                </a>
              : null}
              <ShortcutButton icon="icon-icon_map_layer" isVisible={!this.state.isVisible} isActiveState={false} id="overlays" label="Kartenlayer auswählen" clickHandler={this.onButtonClick} />
              <ShortcutButton icon={mainIconClass} isVisible={this.state.isVisible} isActiveState={false} id="main" labelShow={false} label="Menü" clickHandler={this.onMenuToggle} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default connect(state => state.AppState)(ShortcutMenu);



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/ShortcutMenu/index.js
 **/